import { InputText } from 'primereact/inputtext';
import React, { useState } from 'react'
import { ListBox } from 'primereact/listbox';
import _ from 'lodash'
import ManageBedTags from '../../components/settings/ManageBedTags';
import ManageBedStatus from '../../components/settings/ManageBedStatus';
import ManageBedTypes from '../../components/settings/ManageBedTypes';
import ManageAttendanceStatus from '../../components/settings/ManageAttendanceStatus';

const Settings = () => {
    const [visible, setVisible] = useState(true);
    const [visibleAddStatus, setVisibleAddStatus] = useState(false);
    const [visibleAddType, setVisibleAddType] = useState(false);
    const [visibleAddTag, setVisibleAddTag] = useState(false);
    const [visibleAttendanceStatus, setVisibleAttendanceStatus] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const menu = [
        { name: 'Bed Status', code: '1' },
        { name: 'Bed Tags', code: '2' },
        { name: 'Bed Types', code: '3' },
        { name: 'Attendance Status', code: '4' },

    ];
    const [currentPage, setCurrentPage] = useState(menu[0]);
    const onToggleSideMenu = () => {
        setVisible(prev => !prev)
    }
    const SetCurrentPage = (value) => {
        if(!_.isEmpty(value)){
            setCurrentPage(value)
        }
    }
    const searchOnChange = (value) => {
        setSearchValue(value)
    }
    const addNew = () => {
        switch (currentPage.code) {
            case '1':
                setVisibleAddStatus(prev => !prev)
                break;
            case '2':
                setVisibleAddTag(prev => !prev)
                break;
            case '3':
                setVisibleAddType(prev => !prev)
                break;
            case '4':
                setVisibleAttendanceStatus(prev => !prev)
                break;

            default:
                break;
        }
    }

    return (<div>
        <div className='header-row' style={{ height: '59px' }}>
            <div className='menu-icon'>
                <i className="pi pi-bars" onClick={onToggleSideMenu} />
            </div>
            {/* <div style={{ margin: '17px', width: '300px' }}>
                <h5>{currentPage.name}</h5>
            </div> */}
            <div className="search-box">
                    <span className="p-input-icon-left">
                        <i className="pi pi-search" />
                        <InputText className='search-bar-input' onChange={(e) => searchOnChange(e.target.value)} placeholder="Search" />
                    </span>
            </div>
            <div className='add-btn'>
                <div className='btn-plus' onClick={() => addNew()}>
                    <i className="pi pi-plus" /> New
                </div>
            </div>
        </div>
        <div>
            <div className='data-row'>
                {visible && <div className='p-col-3 p-sm-2'>
                    <ListBox value={currentPage} options={menu} optionLabel="name"
                        onChange={(e) => SetCurrentPage(e.value)}
                        style={{ width: '100%', height: '100%' }} />
                </div>}
                <div className={visible ? " p-col-14 p-lg-10 p-md-10" : "p-col-16 p-lg-12"}>
                    {currentPage && currentPage.code === '1' &&
                        <ManageBedStatus globalFilter={searchValue} toggleSideBar={visibleAddStatus} addNew={addNew}></ManageBedStatus>
                    }
                    {currentPage && currentPage.code === '2' &&
                        <ManageBedTags globalFilter={searchValue} toggleSideBar={visibleAddTag} addNew={addNew}></ManageBedTags>
                    }
                    {currentPage && currentPage.code === '3' &&
                        <ManageBedTypes globalFilter={searchValue} toggleSideBar={visibleAddType} addNew={addNew}></ManageBedTypes>
                    }
                    {currentPage && currentPage.code === '4' &&
                        <ManageAttendanceStatus globalFilter={searchValue} toggleSideBar={visibleAttendanceStatus} addNew={addNew}></ManageAttendanceStatus>
                    }
                </div>
            </div>
        </div>
    </div>)

}

export default Settings;